import { Spin } from "antd";
import styled from "styled-components";

export const SpinnerStyled = styled(Spin)`
  color: var(--dark);
  display: flex;
  justify-content: center;
  align-items: center;
  height: 35vh;
`;
